import * as React from 'react';
import { connect } from 'react-redux';

import * as Edge from '../../../core';
import { withLoadDataDefaultConfig } from '../../../components/loadData';
import errorLoadingWrapperHOC from '../../../components/errorLoadingWrapper/errorLoadingWrapperHOC';
import ExerciseList from '../exerciseList';
import PlanPageBase from '../planPageBase';
import StartButton from '../startButton';
import { PlanService } from '../../../services/planService';
import CompleteEvaluation from './completeEvaluation';
import './index.scss';
import JsonDebug from '../../../components/jsonDebug';
import { CanEvalTeamsBanner } from '../../../components/teamBanner';
import { getTeamsUserCanEval } from '../../../store/permissions/selector';
import { AppState } from '../../../store';
import { setCurrentTeamFromCache } from '../../../store/team/actions';

export interface EvaluationProps {
	currentOrganization?: Edge.Models.Organization;
	currentTeam?: Edge.Models.Team;
	plan: Edge.Models.Plan;
	setCurrentTeamFromCache: (
		currentOrganizationId: string,
		hasCurrentTeam: boolean,
		teams?: Edge.Models.Team[]
	) => void;
	teams?: Edge.Models.Team[];
}

export class Evaluation extends React.PureComponent<EvaluationProps> {
	public componentDidMount() {
		this.setCurrentTeamFromCache();
	}

	public componentDidUpdate() {
		this.setCurrentTeamFromCache();
	}

	public render() {
		const { plan, currentTeam } = this.props;
		return (
			<PlanPageBase
				title="Your Evaluation"
				operationName="Evaluation"
				hideAreaNav
				currentTeam={currentTeam}
				banner={<CanEvalTeamsBanner />}
				plan={plan}
				planPhase={plan.phases[0]}
				renderPlan={this.renderBody}
				renderResults={this.renderResults}
			/>
		);
	}
	private renderResults = () => {
		return <CompleteEvaluation />;
	};
	private renderBody = (trainNow: () => void) => {
		const { plan } = this.props;
		return (
			<div className="evaluation">
				<p>
					Ready to evaluate your visual processing skills? During this evaluation, a series of six exercises
					will determine where your visual processing skills currently stand. At the end of your evaluation,
					you will receive a detailed report, analyzing your visual processing skills, along with your overall
					Edge Score. You will receive an email copy of your report, and your results will also be stored in
					the 'Stats' section so you can track your progress and growth.
				</p>
				<p>
					While the Edge Test typically takes about 15 minutes to complete, you are given 45 minutes to
					complete the entire test. If you do not finish the test in time, your scores will not be saved. Be
					sure to click the <b>'Complete Evaluation'</b> button at the end!
				</p>
				<p>NOTE: These products are not medical devices and have not been reviewed by the FDA.</p>
				<StartButton onClick={trainNow} planPhase={plan.phases[0]} />
				<ExerciseList configs={plan.phases[0].exerciseConfigurations} />
				<JsonDebug data={plan} />
			</div>
		);
	};

	private setCurrentTeamFromCache = () => {
		const { currentOrganization, currentTeam, setCurrentTeamFromCache, teams } = this.props;
		setCurrentTeamFromCache(currentOrganization ? currentOrganization.id : '', !!currentTeam, teams);
	};
}

function mapStateToProps(state: AppState) {
	const { currentOrganization } = state.organizationState;
	return {
		currentOrganization,
		...getTeamsUserCanEval(state),
	};
}

export default connect(
	mapStateToProps,
	{
		setCurrentTeamFromCache,
	}
)(
	withLoadDataDefaultConfig(
		errorLoadingWrapperHOC(Evaluation),
		() => {},
		async () => {
			return {
				plan: await PlanService.getEvaluationPlan(),
			};
		}
	)
);
